<template>
  <div class="producto">
    <div class="contenedor-producto" v-for="(item,index) in DetalleProducto" :key="index">
      <div>
        <!--  Portada  -->
        <div class="contenedor">
          <div class="portada d-flex align-items-center justify-content-center py-5">
            <div class="row text-lg-left">
              <div class="col-12 col-lg-5">
                <titulo-seccion>
                  Gestiona las ventas de tu empresa
                  con {{item.nombre}}
                </titulo-seccion>
                <p>
                  Disfruta del mejor sistema de distribución
                  móvil que puedes encontrar en el mercado
                </p>
                <div>
                  <ul class="lista-producto list-unstyled py-2 py-lg-4 m-0">
                    <li>- Interfaz Intuitiva</li>
                    <li>- Administra tus pedidos</li>
                    <li>- Actividades con GPS</li>
                    <li>- Datos en gráficos</li>
                    <li>- Amplia gama de reportes</li>
                  </ul>
                </div>
              </div>
              <div class="col-12 col-lg-7">
                <div>
                  <img :src="item.imagenDashboard" :title="item.descripcion" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Portada -->
        <!-- Clientes Relacionados -->
        <div class="contenedor bg-light borde-sombreado">
          <cliRelacionados class="contenedor-clientes py-5" img_width="220" :id_prod="item.id" />
        </div>
        <!-- Fin Clientes Relacionados -->
        <!-- Interfaz Sencilla -->
        <div class="contenedor">
          <div class="py-5">
            <titulo-seccion class="m-0">Interfaz simple y fácil de usar</titulo-seccion>
            <p
              class="m-0 py-3"
            >Ntico te permite realizar muchas tareas en poco tiempo con su increíble interfaz</p>
            <div class="d-flex justify-content-center flex-wrap">
              <div class="p-3">
                <img
                  :src="item.imagenReportes"
                  :title="item.descripcion"
                  class="shadow rounded-lg"
                  width="280"
                />
              </div>
              <div class="p-3">
                <img
                  :src="item.imagenPedidos"
                  :title="item.descripcion"
                  width="280"
                  class="shadow rounded-lg"
                />
              </div>
              <div class="p-3">
                <img
                  :src="item.imagenObjetivos"
                  :title="item.descripcion"
                  width="280"
                  class="shadow rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Interfaz Sencilla -->

        <!-- Caracteristicas -->
        <div class="contenedor bg-light borde-sombreado">
          <div class="contenedor-caracteristicas py-5">
            <titulo-seccion>
              ¿Qué puedes hacer con el
              <strong>Ntico Móvil</strong>?
            </titulo-seccion>
            <p
              class="py-3"
            >Gestiona todos los procesos de venta en tu empresa a través de un dispositivo móvil</p>
            <div class="subcontenedor-caracteristicas row">
              <div class="caracteristica col-12 col-md-6 col-lg-4" style="background:">
                <i class="fas fa-shopping-cart icono icono-preventa"></i>
                <h1>Pedidos</h1>
                <p>Realiza y administra pedidos</p>
              </div>
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-file-invoice-dollar icono icono-venta"></i>
                <h1>Facturaciones</h1>
                <p>Realiza facturas rancheras</p>
              </div>
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-file-invoice icono icono-dispositivos"></i>
                <h1>Cotizaciones</h1>
                <p>Realiza cotizaciones a los clientes</p>
              </div>
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-map-marked-alt icono icono-mapas"></i>
                <h1>Rutas</h1>
                <p>Ten a la mano la localización de tus clientes y rutas de ventas</p>
              </div>
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-file-alt icono icono-reportes"></i>
                <h1>Reportes</h1>
                <p>Realiza reportes de ventas, actividades, cuentas, cobros y devoluciones</p>
              </div>
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-bullseye icono icono-objetivos"></i>
                <h1>Objetivos</h1>
                <p>Establece tus objetivos del día y la distribución de tus productos</p>
              </div>
              <div class="caracteristica col-12 col-md-6 col-lg-4">
                <i class="fas fa-wallet icono icono-cxc"></i>
                <h1>Cuentas por cobrar</h1>
                <p>Realiza cobros a los clientes</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Caracteristicas -->
        <!-- Enlace -->
        <div class="contenedor">
          <div class="py-5">
            <div class="my-4">
              <titulo-seccion>
                ¡Descubre la versión Web de
                <b>{{item.nombre}}!</b>
              </titulo-seccion>
              <p
                class="py-2"
                style="font-size: 1.4em; color: #595959"
              >El mejor sistema de distribución móvil</p>
              <boton-enlace to="/SdmWeb" size="lg">Hazlo Ahora</boton-enlace>
            </div>
          </div>
        </div>
        <!-- Fin Enlace -->
        <!-- Reportes Avanzado -->
        <div class="contenedor bg-light borde-sombreado">
          <div class="py-5">
            <titulo-seccion class="pb-3">Reportes Avanzados</titulo-seccion>
            <div class="row">
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-user-tag icono icono"></i>
                <p>Cuadre de Vendedores</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-search-dollar icono"></i>
                <p>Cuadre detallado de Cobros</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-file-invoice-dollar icono"></i>
                <p>Cuadre detallado de Facturas</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-boxes icono"></i>
                <p>Reposición de Inventario</p>
              </div>
              <div class="reporte col-12 col-lg-4 col-xl-3">
                <i class="fas fa-clipboard-list icono"></i>
                <p>Listado de Inventario</p>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Reportes Avanzado -->
        <!-- Contacto -->
        <div class="contenedor">
          <div class="py-5">
            <titulo-seccion class="pb-3">Para saber más de Ntico</titulo-seccion>
            <div class="row justify-content-center">
              <div class="col-12 col-md-4">
                <div style="font-size: 3.7em; color: #595959;" class="mt-3 mb-1">
                  <i class="fas fa-phone-volume"></i>
                </div>
                <p style="font-size: 1.2em;">+1 (809) 241 7309</p>
              </div>
              <div class="col-12 col-md-4">
                <div style="font-size: 3.7em; color: #595959;" class="mt-3 mb-1">
                  <i class="fas fa-mail-bulk"></i>
                </div>
                <router-link to style="font-size: 1.2em;">contacto@adgsystems.com.do</router-link>
              </div>
              <div class="col-12 col-md-4">
                <div style="font-size: 3.7em; color: #595959;" class="mt-3 mb-1">
                  <i class="fas fa-map-marker-alt info-icon"></i>
                </div>
                <router-link
                  style="font-size: 1.2em;"
                >Calle 16 de Agosto, Edif Julian Ramia, Mod 3A. Santiago, R.D.</router-link>
              </div>
            </div>
          </div>
        </div>
        <!-- Fin Contacto -->
      </div>
    </div>
  </div>
</template>
<script>
import cliRelacionados from "@/components/cliente/ClientesRelacionados.vue";
import { mapState } from "vuex";
export default {
  name: "product",
  data() {
    return {
      DetalleProducto: []
    };
  },

  components: {
    cliRelacionados
  },

  computed: {
    ...mapState(["Productos", "Clientes"])
  },

  created() {
    this.producto();
    this.$store.state.colorHeader = true;
  },

  destroyed() {
    this.$store.state.colorHeader = false;
  },

  mounted() {
    window.scrollTo(0, 0);
  },

  methods: {
    producto() {
      /* Productos */
      this.Productos.forEach(item => {
        if (item.id == 2) {
          this.DetalleProducto.push(item);
        }
      });
    }
  }
};
</script>
<style scoped>
/* Portada */
.contenedor-producto {
  padding-top: 60px;
}
.portada {
  min-height: 60vh;
  width: 100%;
  color: #009cff;
}
.portada img {
  max-height: 70vh;
  max-width: 100%;
  width: auto;
}
.lista-producto {
  color: #595959;
  font-weight: 300;
}
.lista-producto {
  font-size: calc(1em + 0.5vw);
}
/* Fin Portada */
/* Contenido */
.contenedor {
  padding: 0 6%;
}
.borde-sombreado {
  -webkit-box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
  -moz-box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
  box-shadow: 0px 0px 8px 0px rgba(250, 250, 250, 1);
}
.contenedor .contenedor-caracteristicas {
  padding: 0 6%;
}
.contenedor p,
.contenedor a {
  color: rgba(0, 0, 0, 0.7);
  font-size: calc(0.9em + 0.5vw);
  font-weight: 400;
}
@media screen and (max-width: 768px) {
  .contenedor p,
  .contenedor a {
    margin: 0;
    font-size: calc(1.1em + 0.5vw);
  }
}
/* --------- */
/* Seccion Caracteristicas */
.contenedor-caracteristicas h1,
.titulo-objetivos {
  padding-top: 14px;
  font-size: calc(1.2em + 0.5vw);
  color: #262626;
}
.caracteristica p {
  margin-top: 0px;
  color: #595959;
  font-weight: 500;
  letter-spacing: -0.2px;
  font-size: calc(0.8em + 0.5vw);
  margin-bottom: 7px;
}
@media screen and (max-width: 768px) {
  .caracteristica p {
    font-size: calc(1em + 0.5vw);
  }
}
.caracteristica {
  margin-bottom: 20px;
}
.caracteristica .icono {
  border-radius: 200px;
  width: 90px;
  height: 90px;
  padding: 22px;
  color: white;
  background: #009cff;
}
/* Fin Caracteristicas */
/* Seccion imagenes */
.portada img {
  object-fit: cover;
  display: block;
}
/* --------------- */
/* Reportes */
.reporte {
  margin: 20px 0px;
  display: flex;
  align-items: center;
}
.reporte .icono {
  border-radius: 200px;
  width: 74px;
  height: 74px;
  padding: 18px;
  color: white;
  -moz-box-shadow: 1px 1px 4px rgba(20, 89, 186, 0.3);
  -webkit-box-shadow: 1px 1px 4px rgba(20, 89, 186, 0.3);
  box-shadow: 1px 1px 4px rgba(20, 89, 186, 0.3);
  background: #009cff;
}
.reporte p {
  text-align: left;
  margin-left: 12px;
  word-break: normal;
  font-size: 1.34em;
  font-weight: 400;
  color: #262626;
  letter-spacing: -0.5px;
}
.titulo-reportes h1 {
  font-size: 2.22em;
}
/* ---- */
</style>
